module.exports = __webpack_public_path__ + "static/media/loaderIcon.feb300ea.svg";